import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://school-improvement.thesendaccountabilityproject.online";
const BRAND = "The SEND Accountability Project";
const DEFAULT = ["Free SEND Toolkits for Schools", "Free, accessible SEND and school improvement toolkits for SENDCOs, school leaders and governors. Fill in online, print or download as PDF. No sign-up."];
const META = {
  "/": DEFAULT,
  "/quick-start": ["Free SENDCO Quick Start Pack", "A free starter pack for new and returning SENDCOs. Complete it online, print it, or download the blank PDF to fill in by hand."],
  "/workbook": ["SENDCO Quick Start Improvement Workbook", "A free guided SEND improvement workbook for schools. Fill it in online, print your answers, or download the blank PDF."],
  "/toolkit-3": ["SEND Master Operational Framework", "A free operational framework to organise SEND systems, roles and reviews across your school. Complete online or download as PDF."],
  "/toolkit-4": ["School Improvement and Turnaround Planner", "Build a free whole-school improvement and turnaround plan with milestones and actions, then print or save it as a PDF."],
  "/printables": ["Classroom Support Printables for SEND", "Free printable classroom support sheets for SEND. Print a single sheet or download all of them as one PDF."],
  "/poster": ["SENDCO Quick Start Poster (A4)", "Download and share the free A4 SENDCO Quick Start poster in your staffroom or school newsletter."],
  "/resources": ["SEND Resource Directory", "Free SEND resources and partner links for schools, SENDCOs and parents, all in one place."],
  "/resource-centre": ["Secure SEND Resource Centre for Schools", "Optional private workspaces where school teams store and share SEND resources securely, with role-based access."],
  "/feedback": ["Share Feedback on the SEND Toolkits", "Tell us what helped and what to improve in the free SEND toolkits. Your feedback shapes the next version."],
  "/impact-review": ["One-Month Impact Review", "Share how the SEND toolkits changed practice in your school one month on. No pupil data is collected."],
  "/contact": ["Contact Us", "Questions about the SEND toolkits, training or data protection? Send us a message and our team will reply."],
  "/accessibility": ["Accessibility Statement", "How the SEND Accountability Project site supports text size, contrast, dyslexia-friendly fonts and reduced motion."],
  "/privacy": ["Privacy Notice", "How the SEND Accountability Project handles data. No pupil-identifiable information is collected by the toolkits."],
  "/disclaimer": ["Disclaimer", "Terms of use and disclaimer for the free SEND Accountability Project toolkits and resources."],
  "/future": ["Coming Soon: New SEND Modules", "Upcoming SEND modules from the SEND Accountability Project, including audits, reviews and transition planning."],
};
const PRIVATE = /^\/(admin|workspace)/;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

/** Per-route title, description, canonical and robots for crawlers that render the app. */
export const RouteMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const [t, d] = META[pathname] || DEFAULT;
    const title = `${t} | ${BRAND}`;
    const url = `${SITE}${pathname === "/" ? "/" : pathname}`;
    document.title = title;
    setMeta("name", "description", d);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", d);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", d);
    setMeta("name", "robots", PRIVATE.test(pathname) ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    document.head.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
  }, [pathname]);
  return null;
};
